module.exports = __webpack_public_path__ + "img/icon-progress-yellow.a734623f.png";